import * as React from "react";
import { styled, useTheme } from "@mui/material/styles";
import Drawer from "@mui/material/Drawer";
import CssBaseline from "@mui/material/CssBaseline";
import MuiAppBar, { AppBarProps as MuiAppBarProps } from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ClickerButton from "./ClickerButton";
import UpgradeContainer from "./UpgradeContainer";
import { useEffect, useState } from "react";

let drawerWidth = (window.innerWidth < 450) ? window.innerWidth : 450;

const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })<{
  open?: boolean;
}>(({ theme, open }) => ({
  flexGrow: 1,
  padding: 0,
  height: "100%",
  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginLeft: 0,
  ...(open && {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: `${drawerWidth}px`,
  }),
}));

interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
}

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})<AppBarProps>(() => ({
  backgroundColor: "#F47D20",
  padding: 0,
  width: "200px",
  float: "left",
  left: 0,
}));

const DrawerHeader = styled("div")(({ theme }) => ({
  color: "#F47D20",
  background: "#000000",
  display: "flex",
  alignItems: "center",
  paddingLeft: "15px",
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

export default function PersistentDrawerLeft() {
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };
  const [drawerWidth, setWindowWidth] = useState((window.innerWidth < 450) ? window.innerWidth : 450);

  useEffect(() => {
    const handleResize = () => {
        setWindowWidth((window.innerWidth < 450) ? window.innerWidth : 450);
    };
  
    window.addEventListener('resize', handleResize);
  
    // Cleanup function to remove the event listener when the component unmounts
    return () => {
        window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className="wrapper">
      <CssBaseline />
      <AppBar position="fixed" open={open}>
        <Toolbar>
          <Typography variant="h6" noWrap component="div">
            Upgrades
          </Typography>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{ m: 1, right: 0, ...(open && { display: "none" }) }}
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Drawer
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            height: "100%",
            justifyContent: "space-between",
            boxSizing: "border-box",
            border: "none",
          },
        }}
        variant="persistent"
        anchor="left"
        open={open}
      >
        <DrawerHeader>
          <Typography variant="h5" noWrap component="div">
            Upgrades
          </Typography>
          <IconButton
          sx={{color: "white"}} onClick={handleDrawerClose}>
            {theme.direction === "ltr" ? (
              <ChevronLeftIcon />
            ) : (
              <ChevronRightIcon />
            )}
          </IconButton>
        </DrawerHeader>
        <UpgradeContainer />
      </Drawer>
      <Main open={open}>
        {/* <DrawerHeader /> */}
        <ClickerButton />
      </Main>
    </div>
  );
}
